import React from 'react';
import './Row.scss';

function Row(props) {
    return <div className={`form__row ${props.classRow}`}>{props.children}</div>
}

export default Row;